export const SingleColor = '#27ae60';
export enum EColorsWeight {
  '#288542' = 4,
  '#9EC71D' = 3,
  '#FEC500' = 2,
  '#FE8600' = 1,
}
export const AllColors: string[] = [
  '#941519',
  '#4572a7',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#aa4643',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
  '#4572a7',
  '#aa4643',
  '#89a54e',
  '#f0d82b',
  '#3d96ae',
  '#80699b',
  '#92a8cd',
];
